import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'cost-plan-header',
    standalone: true,
    templateUrl: './cost-plan-header.html',
    styleUrl: './cost-plan-header.less',
})
export class CostPlanHeaderComponent {
    private router: Router = inject(Router);

    returnHomePage(): void {
        this.router.navigate(['/']);
    }
}
